$(document).on('click', '.editpermissionsbutton', function(evt) {
  evt.preventDefault();
  $('#edit_permissions_modal').load($(this).data('modal-path'));
});
